import React from 'react';
import styles from './NotFound404.module.css';

interface NotFound404Props {
  onGoHome?: () => void;
}

const NotFound404: React.FC<NotFound404Props> = ({ onGoHome }) => {
  const handleGoHome = () => {
    if (onGoHome) {
      onGoHome();
    } else {
      window.location.href = '/';
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>404</h1>
        <p className={styles.subtitle}>Pagina non trovata</p>
        <button onClick={handleGoHome} className={styles.button}>
          Torna al sito
        </button>
      </div>
    </div>
  );
};

export default NotFound404;
